import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './PlaylistActionsMenu.module.scss'

const actionPropTypes = {
  onDownloadMp3: PropTypes.func,
  onDownloadPdf: PropTypes.func,
  onDownloadWav: PropTypes.func,
  onPlay: PropTypes.func,
  onRemove: PropTypes.func
}

const PlaylistActionMenuItem = ({
  callback,
  children,
  destructive,
  disabled,
  itemKey,
  Menu
}) => {
  const handleSelect = (event) => {
    event.stopPropagation()
    callback?.()
  }

  return (
    <Menu.Item
      className={`${styles.menuItem} ${
        destructive ? styles.destructive : ''
      }`}
      data-cy={`playlist-action-${itemKey}`}
      disabled={disabled || !callback}
      onSelect={handleSelect}>
      {children}
    </Menu.Item>
  )
}

PlaylistActionMenuItem.propTypes = {
  callback: PropTypes.func,
  children: PropTypes.node.isRequired,
  destructive: PropTypes.bool,
  disabled: PropTypes.bool,
  itemKey: PropTypes.string.isRequired,
  Menu: PropTypes.object.isRequired
}

const PlaylistActionsMenuContent = ({
  isPlayDisabled,
  Menu,
  onDownloadMp3,
  onDownloadPdf,
  onDownloadWav,
  onPlay,
  onRemove
}) => {
  const { t } = useTranslation()

  const actions = [
    {
      callback: onPlay,
      disabled: isPlayDisabled,
      key: 'play',
      label: t('general.play')
    },
    {
      callback: onDownloadWav,
      key: 'download-wav',
      label: t('playlist.download-wav')
    },
    {
      callback: onDownloadMp3,
      key: 'download-mp3',
      label: t('playlist.download-mp3')
    },
    {
      callback: onDownloadPdf,
      key: 'download-pdf',
      label: t('playlist.download-pdf')
    },
    {
      callback: onRemove,
      destructive: true,
      key: 'remove',
      label: t('playlist.remove-playlist')
    }
  ]

  return actions.map(({ callback, destructive, disabled, key, label }) => (
    <PlaylistActionMenuItem
      key={key}
      callback={callback}
      destructive={destructive}
      disabled={disabled}
      itemKey={key}
      Menu={Menu}>
      {label}
    </PlaylistActionMenuItem>
  ))
}

PlaylistActionsMenuContent.propTypes = {
  isPlayDisabled: PropTypes.bool,
  Menu: PropTypes.object.isRequired,
  ...actionPropTypes
}

export { actionPropTypes }
export default PlaylistActionsMenuContent
